'use client';

import * as React from 'react';
import { cn } from './cn';

export interface SpinnerProps extends React.SVGAttributes<SVGSVGElement> {
  /** xs 12px · sm 16px · md 20px · lg 28px */
  size?: 'xs' | 'sm' | 'md' | 'lg';
  /** Accessible label; omit inside a button that already has text. */
  label?: string;
}

const SPINNER_SIZE = {
  xs: 'size-3',
  sm: 'size-4',
  md: 'size-5',
  lg: 'size-7',
} as const;

/** Indeterminate activity indicator. Draws a ring so it reads at 12 px. */
export const Spinner = React.forwardRef<SVGSVGElement, SpinnerProps>(function Spinner(
  { size = 'sm', label, className, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden={label ? undefined : true}
      role={label ? 'status' : undefined}
      aria-label={label}
      className={cn('animate-spin-soft shrink-0', SPINNER_SIZE[size], className)}
      {...props}
    >
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2.5" opacity="0.22" />
      <path
        d="M21 12a9 9 0 0 0-9-9"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
});
